import React, { Component } from "react";
import TweenOne from "rc-tween-one";
import "./../../assets/styles/Preloader.css";
import pngLoader from '../../assets/images/new/dum-dum-loader.gif';
import { playSong, stopSong } from "../../utils/song";
import songsName from "../../enums/songsName";

class SimpleLoader extends Component {
  static defaultProps = {
    appState: null
  };

  state = {
    isAppInitialized: false
  };

  componentDidUpdate() {
    if (this.props.appState === 'inicializing' || this.props.appState === 'loading') {
      playSong(songsName.ACEAN_WAVES)
    }
    
    if (this.props.appState !== 'inicializing' && this.props.appState !== 'loading') {
      stopSong(songsName.ACEAN_WAVES)

      setTimeout(() => {
        this.setState({
          isAppInitialized: true
        })
      }, 3000)
    }
  }

  render() {
    if (this.state.isAppInitialized) {
      return null;
    }
    return (
      <>
        <div className="preloader_animate">
          <img src={pngLoader} alt="Animated logo" />
        </div>
      </>
    );
  }
}

export default SimpleLoader;
